module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view__tabs"
  }, [_c('ul', {
    staticClass: "view__tabs--menu"
  }, [_c('li', {
    class: _vm.getCssClass(['payment-options', 'payment-option', 'payment-option-create'])
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'payment-options'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Membership_Breadcrumb_PaymentOptions')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass(['taxes', 'tax', 'tax-create'])
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'taxes'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Membership_Breadcrumb_Taxes')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('payment-gateways')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'payment-gateways'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Settings_Breadcrumb_Billing')) + "\n            ")])], 1)]), _vm._v(" "), (_vm.showActions) ? _c('dropdown', {
    attrs: {
      "label": _vm.actions.label,
      "links": _vm.actions.links,
      "acc": "actions",
      "isNotSync": true
    },
    on: {
      "delete": _vm.deleteCurrent
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75562449!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/membership/Submenu.vue
// module id = 747
// module chunks = 1